<template>
  <div class="step step--clean-air-interactive clean-air-interactive">

    <div class="clean-air-interactive__text">
      <template v-if="powerLevel < 6"><span v-html="$t('increasePower.title')"></span></template>
      <template v-else><span v-html="$t('increasePower.titleReady')"></span></template>
    </div>

    <div
        class="cleaning-process__controls"
    >
      <div class="cleaning-process__power-level power-level">
        <div class="power-level" :class="'power-level--' + powerLevel">
          <div class="power-level__controls">
            <button @click="decreasePower" :class="{'disabled' : powerLevel <= 0}" class="power-level__control power-level__control--left">
              <img src="@/assets/img/minus.svg" alt="">
            </button>
            <button @click="increasePower" :class="{'disabled' : powerLevel >= 6}" class="power-level__control power-level__control--right">
              <img src="@/assets/img/plus.svg" alt="">
            </button>
          </div>
          <div class="power-level__img" v-for="(i, index) in levels" :key="index" :class="{'active' : powerLevel === i}">
            <img :src="require('../../assets/img/power-level-' + i + '.png')" :alt="'power-level ' + i">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
  name: 'StepIncreasePower',
  props: {},

  components: {},

  data() {
    return {
      levels: [0,1,2,3,4,5,6],
      powerLevel: 0,
      timeoutQuery: null
    }
  },

  mounted () {
    if (this.$gtm) {
      this.$gtm.trackEvent({
        'event': 'Event',
        'analytics_action': this.$store.state.step + '-mounted',
        'analytics_label': this.$store.state.step,
      })
    }
  },

  created () {},

  updated () {},

  methods: {
    increasePower () {
      this.powerLevel += 2

      if (this.$gtm) {
        this.$gtm.trackEvent({
          'event': 'Event',
          'analytics_action': this.$store.state.step + '-button-increase-power',
          'analytics_label': this.$store.state.step,
        })
      }
    },

    decreasePower() {
      this.powerLevel -= 2

      if (this.$gtm) {
        this.$gtm.trackEvent({
          'event': 'Event',
          'analytics_action': this.$store.state.step + '-button-decrease-power',
          'analytics_label': this.$store.state.step,
        })
      }
    },

    next () {
      this.$store.commit('setStep', 'climate-control')
    },

    powerLevelCheck(val) {
      if(!this.isIos) {
        if(this.powerLevel > 1 && this.powerLevel < 4 && this.modelNum !== 6) {
          this.$store.commit('setModel', 6)
          this.$store.commit('setClouds', 3)
        }

        if(this.powerLevel === 4 && this.modelNum !== 7) {
          this.$store.commit('setModel', 7)
          this.$store.commit('setClouds', 4)
        }

        if(this.powerLevel === 6 && this.modelNum !== 8) {
          this.$store.commit('setModel', 8)
          this.$store.commit('setClouds', 4)
        }
      } else {
        if(this.powerLevel > 1 && this.powerLevel < 4 && this.modelNum !== 3) {
          this.$store.commit('setModel', 6)
          this.$store.commit('setClouds', 3)
        }

        if(this.powerLevel === 4 && this.modelNum !== 5) {
          this.$store.commit('setModel', 7)
          this.$store.commit('setClouds', 5)
        }

        if(this.powerLevel === 6 && this.modelNum !== 8) {
          this.$store.commit('setModel', 8)
          this.$store.commit('setClouds', 4)
        }
      }


      if (val === 6) {
        setTimeout(() => {
          if (this.$gtm) {
            this.$gtm.trackEvent({
              'event': 'Event',
              'analytics_action': this.$store.state.step + '-increase-power-done',
              'analytics_label': this.$store.state.step,
            })
          }

          this.next()
        }, 2000)
      }
    }
  },

  watch: {
    powerLevel (val) {
      if (this.timeoutQuery) { clearTimeout(this.timeoutQuery) }
      this.timeoutQuery = setTimeout(() => this.powerLevelCheck(val), 200)
    },
  },

  computed: {
    isIos() {
     return /iPad|iPhone|iPod/.test(navigator.platform)
          || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    },
    ...mapState({
      step: state => state.step,
      modelNum: state => state.model
    })
  }
}
</script>

<style lang="scss" scoped>

</style>
